import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import BottomTab from "../../../../components/pagination/BottomTab";
import EventIcon from "@mui/icons-material/Event";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

function UpcommingTable({ theme = "light" }: { theme?: "light" | "dark" }) {
  const [appointments, setappointments] = useState([]);
  const [count, setcount] = useState(0);
  const [page, setpage] = useState(1);
  const isDark = theme === "dark";

  const getdata = (pages: any) => {
    baseUrl
      .get("dashboard/upcommingAppointment", {
        headers: { page: pages },
      })
      .then((response) => {
        console.log(response.data.data);
        
        setappointments(response.data.data);
        setcount(response.data.count);
      })
      .catch((error) => {
        console.error(error.response);
      });
  };

  useEffect(() => {
    getdata(page);
  }, []);

  const onPageChange = (e: any) => {
    getdata(e);
    setpage(e);
  };

  return (
    <div className={`rounded-2xl shadow-lg border overflow-hidden transition-all duration-300 ${
      isDark 
        ? "bg-slate-800 border-slate-700 shadow-slate-900/50" 
        : "bg-white border-slate-100 shadow-slate-200/50"
    }`}>
      {/* Header */}
      <div className={`px-6 py-4 border-b flex items-center justify-between ${
        isDark ? "border-slate-700" : "border-slate-100"
      }`}>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-primary to-primaryLight rounded-xl flex items-center justify-center">
            <EventIcon className="text-white" sx={{ fontSize: 20 }} />
          </div>
          <h3 className={`text-lg font-bold ${
            isDark ? "text-slate-100" : "text-slate-800"
          }`}>Upcoming Appointments</h3>
        </div>
        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
          isDark 
            ? "bg-indigo-900/30 text-indigo-300 border border-indigo-800/50" 
            : "bg-indigo-50 text-indigo-600"
        }`}>
          {count} Total
        </span>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden p-4 space-y-3">
        {appointments?.length === 0 ? (
          <div className={`text-center py-8 ${
            isDark ? "text-slate-500" : "text-slate-400"
          }`}>
            <EventIcon sx={{ fontSize: 48 }} className="mb-2" />
            <p>No upcoming appointments</p>
          </div>
        ) : (
          appointments?.map((item: any, index: number) => (
            <div
              key={index}
              className={`rounded-xl p-4 border ${
                isDark 
                  ? "bg-slate-700/50 border-slate-600" 
                  : "bg-slate-50 border-slate-100"
              }`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white font-semibold text-sm">
                    {item?.patientId?.fullName?.charAt(0)?.toUpperCase()}
                    {item?.bookPatientId?.fullName?.charAt(0)?.toUpperCase()}
                  </div>
                  <div>
                    <p className={`font-semibold ${
                      isDark ? "text-slate-100" : "text-slate-800"
                    }`}>
                      {item?.patientId?.fullName}
                      {item?.bookPatientId?.fullName}
                    </p>
                    <p className={`text-xs ${
                      isDark ? "text-slate-400" : "text-slate-500"
                    }`}>
                      {item?.doctorId?.firstName} {item?.doctorId?.lastName}
                    </p>
                  </div>
                </div>
              </div>
              <div className={`grid grid-cols-2 gap-2 text-sm ${
                isDark ? "text-slate-300" : "text-slate-600"
              }`}>
                <div className="flex items-center gap-2">
                  <EventIcon sx={{ fontSize: 16 }} className={isDark ? "text-slate-500" : "text-slate-400"} />
                  <span>{item?.date?.split("T")[0]}</span>
                </div>
                <div className="flex items-center gap-2">
                  <AccessTimeIcon sx={{ fontSize: 16 }} className={isDark ? "text-slate-500" : "text-slate-400"} />
                  <span>{item?.startTime}</span>
                </div>
                <div className="flex items-center gap-2 col-span-2">
                  <PhoneIcon sx={{ fontSize: 16 }} className={isDark ? "text-slate-500" : "text-slate-400"} />
                  <span>{item?.patientId?.mobileNo} </span>
                  <span>{item?.bookPatientId?.phoneNumber}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className={isDark ? "bg-slate-700/50" : "bg-slate-50/80"}>
              <th className={`px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider ${
                isDark ? "text-slate-400" : "text-slate-500"
              }`}>
                <div className="flex items-center gap-2">
                  <PersonIcon sx={{ fontSize: 16 }} />
                  Patient Name
                </div>
              </th>
              <th className={`px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider ${
                isDark ? "text-slate-400" : "text-slate-500"
              }`}>
                <div className="flex items-center gap-2">
                  <EventIcon sx={{ fontSize: 16 }} />
                  Date
                </div>
              </th>
              <th className={`px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider ${
                isDark ? "text-slate-400" : "text-slate-500"
              }`}>
                <div className="flex items-center gap-2">
                  <AccessTimeIcon sx={{ fontSize: 16 }} />
                  Time
                </div>
              </th>
              <th className={`px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider ${
                isDark ? "text-slate-400" : "text-slate-500"
              }`}>
                <div className="flex items-center gap-2">
                  <PhoneIcon sx={{ fontSize: 16 }} />
                  Contact
                </div>
              </th>
              <th className={`px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider ${
                isDark ? "text-slate-400" : "text-slate-500"
              }`}>
                <div className="flex items-center gap-2">
                  <EventIcon sx={{ fontSize: 16 }} />
                  Type
                </div>
              </th>
              <th className={`px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider ${
                isDark ? "text-slate-400" : "text-slate-500"
              }`}>
                <div className="flex items-center gap-2">
                  <LocalHospitalIcon sx={{ fontSize: 16 }} />
                  Dentist
                </div>
              </th>
            </tr>
          </thead>
          <tbody className={isDark ? "divide-y divide-slate-700" : "divide-y divide-slate-100"}>
            {appointments?.length === 0 ? (
              <tr>
                <td colSpan={6} className={`px-6 py-12 text-center ${
                  isDark ? "text-slate-500" : "text-slate-400"
                }`}>
                  <EventIcon sx={{ fontSize: 48 }} className="mb-2" />
                  <p>No upcoming appointments</p>
                </td>
              </tr>
            ) : (
              appointments?.map((item: any, index: number) => (
                <tr key={index} className={`transition-colors ${
                  isDark ? "hover:bg-slate-700/50" : "hover:bg-slate-50/50"
                }`}>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white font-semibold text-sm">
                        {item?.patientId?.fullName?.charAt(0)?.toUpperCase()}
                        {item?.bookPatientId?.fullName?.charAt(0)?.toUpperCase()}
                      </div>
                      <span className={`font-medium ${
                        isDark ? "text-slate-200" : "text-slate-800"
                      }`}>
                        {item?.patientId?.fullName}
                        {item?.bookPatientId?.fullName}
                      </span>
                    </div>
                  </td>
                  <td className={`px-6 py-4 text-sm ${
                    isDark ? "text-slate-300" : "text-slate-600"
                  }`}>
                    {item?.date?.split("T")[0]}
                  </td>
                  <td className="px-6 py-4">
                    <span className={`px-2.5 py-1 rounded-lg text-sm font-medium ${
                      isDark 
                        ? "bg-indigo-900/30 text-indigo-300 border border-indigo-800/50" 
                        : "bg-indigo-50 text-indigo-600"
                    }`}>
                      {item?.startTime}
                    </span>
                  </td>
                  <td className={`px-6 py-4 text-sm ${
                    isDark ? "text-slate-300" : "text-slate-600"
                  }`}>
                    {item?.patientId?.mobileNo}
                    {item?.bookPatientId?.phoneNumber}
                  </td>
                  <td className={`px-6 py-4 text-sm ${
                    isDark ? "text-slate-300" : "text-slate-600"
                  }`}>
                      {item?.type}
                  </td>
                  <td className={`px-6 py-4 text-sm ${
                    isDark ? "text-slate-300" : "text-slate-600"
                  }`}>
                    Dr. {item?.doctorId?.firstName} {item?.doctorId?.lastName}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className={`border-t ${
        isDark ? "border-slate-700" : "border-slate-100"
      }`}>
        <BottomTab title={"Appointments"} count={count} onPageChange={onPageChange} />
      </div>
    </div>
  );
}

export default UpcommingTable;
